import axios from "axios";
import authHeader from "../utils/auth/auth-header";
import { SERVER_URL } from "../../config/env";

class AppService {
  constructor() {
    this.base = SERVER_URL + "ksbhub/";
  }

  /**
   * ✅ GET all users
   */
  async getUsers() {
    try {
      const response = await axios.get(this.base + "allusers", {
        headers: authHeader(),
      });
      return response.data;
    } catch (e) {
      console.error("❌ getUsers error:", e);
      return [];
    }
  }

  /**
   * ✅ UPDATE user (admin)
   */
  async updateUser(userId, data) {
    try {
      const response = await axios.put(`${this.base}user/${userId}`, data, {
        headers: authHeader(),
      });

      return response.data;
    } catch (e) {
      console.error("❌ updateUser error:", e);
      throw e;
    }
  }
}

const appService = new AppService();
export default appService;
